import React from 'react';
import './OrderProduct.css';
import star from '../../assets/images/star.png';

function OrderProduct({
  id,
  title,
  image,
  price,
  rating,
  quantity,
  description,
}) {
  let totalPrice = Number((price * quantity).toFixed(2));
  const priceDollars = totalPrice.toString().split('.')[0];
  let priceCents = totalPrice.toString().split('.')[1];
  if (priceCents === undefined) priceCents = '00';
  if (priceCents.length < 2) priceCents += '0';

  return (
    <div className="orderProduct">
      <img className="orderProduct__image" src={image} alt="" />
      <div className="orderProduct__info">
        <p className="orderProduct__title">
          {title} x {quantity === undefined ? 1 : quantity}
        </p>
        <div className="orderProduct__rating">
          {Array(rating)
            .fill()
            .map((_, index) => (
              <p key={index}>
                <img className="product__ratingStar" src={star} alt="" />
              </p>
            ))}
        </div>
      </div>
      <div className="orderProduct__priceContainer">
        <p className="orderProduct__price">
          <span className="app__priceSymbol">$</span>
          <strong className="app__priceDollars">{priceDollars}</strong>
          <span className="app__priceCents">{priceCents}</span>
        </p>
      </div>
    </div>
  );
}

export default OrderProduct;
